var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Checkbox } from './checkbox';
var cls = classNames('form-field-checkbox');
export var FormFieldCheckboxDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var target = _a.target;
    return target === 'grid' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(3));
  })
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Checkbox: styled(Checkbox)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles)
};
export var FormFieldCheckbox = function (props) {
  var className = props.className,
    value = props.value,
    name = props.name;
  var checked = !!props.value;
  var handleChange = props.onChange && function (checked) {
    props.onChange({
      value: !!checked
    });
  };
  return React.createElement(My.Container, {
    target: props.target,
    className: cls.name(className)
  }, React.createElement(My.Checkbox, {
    id: name,
    // valid={field.valid}
    onChange: handleChange,
    checked: checked,
    value: value,
    size: 24
  }));
};
FormFieldCheckbox.cls = cls;
FormFieldCheckbox.defaultProps = FormFieldCheckboxDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;